<template>
  <myhead  @next="next" @lookmore="more">{{ $route.query.title || $route.meta.title}}</myhead>
  <div class="center mt25 mb20 userUpload">
    <van-uploader style="background:#dbdbdb"
    :style="$store.state.loginInfo.head_pic?'background-size:cover;background:#dbdbdb url('+$store.state.loginInfo.head_pic+') center no-repeat':''" :after-read="afterRead" name="file" />
  </div>
  <div class="myField vh20">
    <div>
      <van-field v-model="nickname" label="用户名:" placeholder="请填写用户名" />
    </div>
    <p class="Cred mb8 ml92" v-show="errorMsg">{{errorMsg}}</p>
  </div>

  <div class="pad15">
    <div class="flex right Con mb8">
      <!-- <div @click="showAgreement" class="pad8 size14">用户名修改规则</div> --> 
    </div>
    <van-button type="primary" round block @click="next">确认</van-button>
    <p class="size12 Corange width94 mt20 auto">4-20个字符,仅支持中英文、数字、下划线，不含敏感词汇<br />人工审核后通过。</p>
  </div>
</template>
<script>

export default {
  name: 'Name',
  data(){
    return {
      nickname:'',
      agreement:'',
      errorMsg:''
    }
  },
  methods:{
    showAgreement(){
      this.showDialog({
        allowHtml:true,
        title: '用户名修改规则',
        message: '<div style="text-align:left">'+this.agreement+'</div>'
      })
    },
    afterRead(file){
      this.ajax.post("api/dyuploadimg",{
        file:file.file
      },{headers: {
        'Content-Type': 'multipart/form-data'
      }}).then(({data})=>{
        this.head_pic = data.url;
        this.$store.state.loginInfo.head_pic = data.img;
        localStorage.setItem("loginInfo",JSON.stringify(this.$store.state.loginInfo));
      })
    },
    next(){
      if(this.$route.path.includes("register")){
        this.ajax({method:"post",url:"users/registeruser",data:{
          id:this.$store.state.loginInfo.id,
          nickname:this.nickname||'',
          head_pic:this.head_pic||''
        },myData:{showMsg:false}}).then(()=>{
          // this.$router.push({path:'/agreement',query:{typeid:3} });
          this.$router.push({path:'/register/status',query:{type:"waiting"} });
        }).catch(({message})=>{
          this.errorMsg = message;
        })
      }else{
        //这个用不到了其实，但留个记录吧
        let params = {
          head_pic:this.head_pic||this.$store.state.loginInfo.head_pic,
          nickname:this.nickname||''
        };
        this.ajax.post("users/setinfo",{...params,typeid:3}).then(()=>{
          this.$store.state.loginInfo = { ...this.$store.state.loginInfo,...params };
          localStorage.setItem("loginInfo",JSON.stringify(this.$store.state.loginInfo));
          this.$router.back()
        })
      }
    }
  },
  created(){
    this.nickname = this.$store.state.loginInfo.nickname;
    this.ajax.post("api/getagreement",{typeid:1}).then(({data})=>{
      this.agreement = data.content;
    })
  }
}
</script>

<style>
</style>
